<!-- ── New Customer Slide-in Drawer ────────────────────────────────────── -->
<div class="customer-panel-backdrop" *ngIf="opened" (click)="closeDrawer()"></div>
<div class="customer-panel" [class.customer-panel--open]="opened">
  <div class="drawer-header">
    <span class="drawer-title">New Customer</span>
    <button mat-icon-button (click)="closeDrawer()" type="button">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div class="drawer-body">

    <!-- Name (required, a-z 0-9 - . _) -->
    <mat-form-field appearance="outline" class="form-field-full">
      <mat-label>Name *</mat-label>
      <mat-icon matPrefix>business</mat-icon>
      <input matInput [(ngModel)]="newCustomer.name" #custName="ngModel" name="custName" required
        pattern="^[a-zA-Z0-9_.\- ]+$" (ngModelChange)="onCustomerNameInput($event)" placeholder="Company or person name"
        autocomplete="off">
      <mat-hint *ngIf="customerNameChecking">Checking availability…</mat-hint>
      <mat-error *ngIf="custName.hasError('required')">Name is required</mat-error>
      <mat-error *ngIf="custName.hasError('pattern')">Only letters, numbers, spaces, hyphens, underscores and dots are
        allowed</mat-error>
    </mat-form-field>
    <div class="drawer-inline-error"
      *ngIf="!custName.hasError('required') && !custName.hasError('pattern') && customerNameTaken">
      <mat-icon class="error-icon">error</mat-icon>
      Name already exists
    </div>

    <!-- Address (free text, optional) -->
    <mat-form-field appearance="outline" class="form-field-full">
      <mat-label>Address</mat-label>
      <mat-icon matPrefix>location_on</mat-icon>
      <input matInput [(ngModel)]="newCustomer.address" name="custAddress" placeholder="Street, city, state"
        autocomplete="off">
    </mat-form-field>

    <!-- Website (optional) -->
    <mat-form-field appearance="outline" class="form-field-full">
      <mat-label>Website</mat-label>
      <mat-icon matPrefix>language</mat-icon>
      <input matInput [(ngModel)]="newCustomer.website" #custWebsite="ngModel" name="custWebsite"
        pattern="^(https?:\/\/)?([\w\-]+(\.[\w\-]+)+)(\/[\w\-.,@?^=%&:\/~+#]*)?$" placeholder="https://example.com"
        autocomplete="off">
      <mat-error *ngIf="custWebsite.hasError('pattern')">Enter a valid URL (e.g. https://example.com)</mat-error>
    </mat-form-field>

    <!-- GST Number (optional, alphanumeric only) -->
    <mat-form-field appearance="outline" class="form-field-full">
      <mat-label>GST Number</mat-label>
      <mat-icon matPrefix>receipt_long</mat-icon>
      <input matInput [(ngModel)]="newCustomer.gstNumber" #custGst="ngModel" name="custGst" pattern="^[a-zA-Z0-9]+$"
        placeholder="e.g. 22AAAAA0000A1Z5" autocomplete="off">
      <mat-error *ngIf="custGst.hasError('pattern')">GST number must be alphanumeric only</mat-error>
    </mat-form-field>

    <!-- Contact Person (optional, letters + ' - only) -->
    <mat-form-field appearance="outline" class="form-field-full">
      <mat-label>Contact Person</mat-label>
      <mat-icon matPrefix>person</mat-icon>
      <input matInput [(ngModel)]="newCustomer.contactPerson.name" #custContactName="ngModel" name="custContactName"
        pattern="^[a-zA-Z' \-]+$" placeholder="Full name" autocomplete="off">
      <mat-error *ngIf="custContactName.hasError('pattern')">Only letters, spaces, apostrophes and hyphens are
        allowed</mat-error>
    </mat-form-field>

    <!-- Contact Email (optional, email format) -->
    <mat-form-field appearance="outline" class="form-field-full">
      <mat-label>Contact Email</mat-label>
      <mat-icon matPrefix>email</mat-icon>
      <input matInput [(ngModel)]="newCustomer.contactPerson.email" #custEmail="ngModel" name="custEmail" type="email"
        email placeholder="email@example.com" autocomplete="off">
      <mat-error *ngIf="custEmail.hasError('email')">Enter a valid email address</mat-error>
    </mat-form-field>

    <!-- Contact Phone (optional, international phone format) -->
    <mat-form-field appearance="outline" class="form-field-full">
      <mat-label>Contact Phone</mat-label>
      <mat-icon matPrefix>phone</mat-icon>
      <input matInput [(ngModel)]="newCustomer.contactPerson.mobile" #custPhone="ngModel" name="custPhone" type="tel"
        pattern="^\+?[0-9\s\-().]{7,20}$" placeholder="e.g. +91 98765 43210" autocomplete="off">
      <mat-error *ngIf="custPhone.hasError('pattern')">Enter a valid phone number</mat-error>
    </mat-form-field>

  </div>
  <div class="drawer-actions">
    <button mat-stroked-button type="button" (click)="closeDrawer()">Cancel</button>
    <button mat-raised-button color="primary" type="button"
      [disabled]="isSaveButtonDisabled()"
      (click)="saveNewCustomer()">Save</button>
  </div>
</div>
